import { MenuItem } from 'shared';
import { Nullable } from 'shared_DEPRECATED/types';

import { PrioritizeGoalCallback } from 'features/goal/types';

export const GoalCardMenuPrioritizeButton = ({
  goalId,
  prioritizedAt,
  columnId,
  togglePrioritize,
}: {
  goalId: string;
  columnId: string;
  prioritizedAt: Nullable<string>;
  togglePrioritize: PrioritizeGoalCallback;
}) => {
  const isPrioritized = !!prioritizedAt;

  const handleMenuClick = (event: MouseEvent) => {
    event.preventDefault();
    togglePrioritize(goalId, isPrioritized, columnId);
  };

  return (
    <MenuItem onClick={handleMenuClick}>
      {`${isPrioritized ? 'Unset' : 'Set'} as prioritized`}
    </MenuItem>
  );
};
